// extracted by mini-css-extract-plugin
module.exports = {"container":"PayBrightLink__container___1CSNF","link":"PayBrightLink__link___wJ2Td typography__link-underline-gray___y2Suw","logo":"PayBrightLink__logo___JY_Kr"};